export const build = "v3";
const LOCAL_SERVER = "http://localhost:61960";
const REMOTE_SERVER = `https://${build}.explorug.com`;
const severToUse = REMOTE_SERVER;
export const baseUrl = severToUse;
export const getLoginUrl = () => {
  if (process.env.NODE_ENV === "development") return "http://localhost:23456?forcelogin";
  return severToUse === LOCAL_SERVER || build === "v3"
    ? `${baseUrl}/index.html?forcelogin`
    : `${baseUrl}/build/index.html?forcelogin`;
};
export const apiUrl = `${severToUse}/appproviderv3.aspx`;
export const fileApiUrl = `${severToUse}/managefiles.aspx`;

export const colorTypes = ["Hidden", "Placeholder", "ColorOnly", "ColorAndMaterial"];
export const clipboardOperations = { COPY: "COPY", CUT: "CUT" };
export const formatClipboardOperations = (operation, done) => {
  if (operation === clipboardOperations.CUT) return done ? "Moved" : "Moving";
  if (operation === clipboardOperations.COPY) return done ? "Copied" : "Copying";
};
export const acceptedExtensions = {
  JPEG: { arr: ["jpg"], ext: ".jpg" },
  CTF: { arr: ["png", "ctf"], ext: ".png,.ctf" },
};
//**Dialog State constants */
export const uploadErrStatus = {
  NONE: null,
  NO_INTERNET: "NO_INTERNET",
  CTF_MISMATCH: "CTF_MISMATCH",
  SERVICE_FAILURE: "SERVICE_FAILURE",
};
export const duplicateEntryTypes = {
  NONE: null,
  FILE: "file",
  FOLDER: "folder",
};
